export const STANDARD_DRAWINGS = [
    ['Ellipse', 'Shapes', 2], ['Triangle', 'Shapes', 3], ['Rotated Rectangle', 'Shapes', 3],
    ['Fib Fan', 'Fibonacci', 2], ['Fib Arcs', 'Fibonacci', 2], ['Fib Time Zone', 'Fibonacci', 2],
    ['Gann Fan', 'Gann', 2], ['Gann Box', 'Gann', 2],
    ['ABCD Pattern', 'Patterns', 4], ['XABCD Pattern', 'Patterns', 5],
    ['Elliott Impulse Wave', 'Patterns', 6], ['Elliott Correction Wave', 'Patterns', 4],
    ['Head and Shoulders', 'Patterns', 7], ['Triangle Pattern', 'Patterns', 5],
    ['Curve', 'Shapes', 3], ['Arc', 'Shapes', 3], ['Fib Channel', 'Fibonacci', 3],
    ['Fib Circles', 'Fibonacci', 2], ['Fib Spiral', 'Fibonacci', 2],
    ['Speed Resistance Fan', 'Fibonacci', 2], ['Cypher Pattern', 'Patterns', 5],
    ['Three Drives Pattern', 'Patterns', 7], ['Sine Line', 'Cycles', 2], ['Forecast', 'Forecasting', 3],
    ['Circle','Shapes',2], ['Double Curve','Shapes',4],
    ['Path','Shapes',0], ['Polyline','Shapes',0], ['Brush','Shapes',0], ['Highlighter','Shapes',0],
    ['Arrow Marker','Shapes',2],
    ['Trend-Based Fib Time','Fibonacci',3], ['Fib Wedge','Fibonacci',3], ['Pitchfan','Fibonacci',3],
    ['Gann Square','Gann',2], ['Gann Square Fixed','Gann',2],
    ['Time Cycles','Cycles',2], ['Elliott Triangle Wave','Patterns',6],
    ['Elliott Double Combo Wave','Patterns',4], ['Elliott Triple Combo Wave','Patterns',6],
    ['Anchored VWAP','Volume',1], ['Anchored Volume Profile','Volume',1],
    ['Bars Pattern','Forecasting',3], ['Ghost Feed','Forecasting',2], ['Projection','Forecasting',3],
    ['Position Forecast','Forecasting',3], ['Sector','Forecasting',3],
    ['Callout','Annotations',2], ['Note','Annotations',1], ['Price Note','Annotations',2],
    ['Anchored Text','Annotations',1], ['Anchored Note','Annotations',1],
    ['Pin','Annotations',1], ['Table','Annotations',1], ['Comment','Annotations',1],
    ['Price Label','Annotations',1], ['Signpost','Annotations',1], ['Flag Mark','Annotations',1],
    ['Arrow Mark Up','Annotations',1], ['Arrow Mark Down','Annotations',1],
    ['Arrow Mark Left','Annotations',1], ['Arrow Mark Right','Annotations',1],
    ['Image','Annotations',2], ['X Post','Annotations',1], ['Idea','Annotations',1],
    ['Measure','Measurements',2], ['Zoom In','Measurements',2],
    ['Icon','Annotations',1], ['Emoji','Annotations',1], ['Sticker','Annotations',1],
];
export const FIB_RATIOS = [0, .236, .382, .5, .618, .786, 1];
export function drawingGeometry(kind, points, width = 1000) {
    if (points.length < 2) return [];
    const [a,b,c] = points;
    const dx = b[0]-a[0], dy = b[1]-a[1];
    const line = (p,q,label) => ({ type: 'line', points: [p,q], label });
    const polygon = (p,labels) => ({ type: 'polygon', points:p, labels });
    if (kind === 'Curve') return c ? [{type:'quadratic',points:[a,b,c]}] : [line(a,b)];
    if (kind === 'Arc') {
        if (!c) return [line(a,b)];
        const determinant=2*(a[0]*(b[1]-c[1])+b[0]*(c[1]-a[1])+c[0]*(a[1]-b[1]));
        if (Math.abs(determinant)<1e-8) return [line(a,c)];
        const squared=p=>p[0]*p[0]+p[1]*p[1];
        const cx=(squared(a)*(b[1]-c[1])+squared(b)*(c[1]-a[1])+squared(c)*(a[1]-b[1]))/determinant;
        const cy=(squared(a)*(c[0]-b[0])+squared(b)*(a[0]-c[0])+squared(c)*(b[0]-a[0]))/determinant;
        const angle=p=>Math.atan2(p[1]-cy,p[0]-cx);
        const start=angle(a),middle=angle(b),end=angle(c),tau=Math.PI*2;
        const positive=x=>(x+tau)%tau;
        return [{type:'circleArc',center:[cx,cy],radius:Math.hypot(a[0]-cx,a[1]-cy),start,end,anticlockwise:positive(middle-start)>positive(end-start)}];
    }
    if (kind === 'Fib Channel') {
        if (!c || !dx) return [line(a,b)];
        const offset=c[1]-(a[1]+(c[0]-a[0])*dy/dx);
        return [0,.236,.382,.5,.618,.786,1,1.618,2.618].map(r=>line([a[0],a[1]+offset*r],[b[0],b[1]+offset*r],String(r)));
    }
    if (kind === 'Fib Circles') return [.236,.382,.5,.618,.786,1,1.618].map(r=>({type:'ellipse',center:a,radius:[Math.hypot(dx,dy)*r,Math.hypot(dx,dy)*r]}));
    if (kind === 'Fib Spiral') {
        const radius=Math.hypot(dx,dy),angle=Math.atan2(dy,dx),pts=[];
        for(let i=0;i<=240;i++) {const t=-Math.PI*4+i/240*Math.PI*4,r=radius*Math.pow(1.61803398875,t/(Math.PI/2));pts.push([a[0]+r*Math.cos(angle+t),a[1]+r*Math.sin(angle+t)]);}
        return [{type:'path',points:pts}];
    }
    if (kind === 'Speed Resistance Fan') return [1/3,2/3,1].map(r=>line(a,[b[0],a[1]+dy*r],String(r)));
    if (kind === 'Sine Line') {
        const pts=[];
        for(let i=0;i<=128;i++){const fraction=i/128;pts.push([a[0]+dx*fraction,a[1]+dy*Math.sin(fraction*Math.PI*2)]);}
        return [{type:'path',points:pts}];
    }
    if (kind === 'Ellipse') return [{ type:'ellipse', center:[(a[0]+b[0])/2,(a[1]+b[1])/2], radius:[Math.abs(dx)/2,Math.abs(dy)/2] }];
    if (kind === 'Triangle') return c ? [polygon([a,b,c])] : [line(a,b)];
    if (kind === 'Rotated Rectangle') {
        if (!c) return [line(a,b)];
        const norm = dx*dx+dy*dy;
        const projection = norm ? ((c[0]-a[0])*dx+(c[1]-a[1])*dy)/norm : 0;
        const offset=[c[0]-a[0]-projection*dx,c[1]-a[1]-projection*dy];
        return [polygon([a,b,[b[0]+offset[0],b[1]+offset[1]],[a[0]+offset[0],a[1]+offset[1]]])];
    }
    if (kind === 'Fib Fan' || kind === 'Gann Fan') {
        if (!dx) return [];
        const ratios = kind === 'Fib Fan' ? [.382,.5,.618,.786,1] : [.125,.25,.5,1,2,4,8];
        const end = dx > 0 ? width : 0;
        return ratios.map(r => line(a,[end,a[1]+(end-a[0])*dy/dx*r],String(r)));
    }
    if (kind === 'Fib Arcs') return [.382,.5,.618,1].map(r => ({ type:'arc', center:a, radius:Math.hypot(dx,dy)*r, upper:dy<0, label:String(r) }));
    if (kind === 'Fib Time Zone') return [0,1,2,3,5,8,13,21,34].map(r => ({ type:'vertical', x:a[0]+dx*r,label:String(r) }));
    if (kind === 'Gann Box') return [polygon([a,[b[0],a[1]],b,[a[0],b[1]]]), ...FIB_RATIOS.slice(1,-1).flatMap(r => [
        line([a[0]+dx*r,a[1]],[a[0]+dx*r,b[1]],String(r)),
        line([a[0],a[1]+dy*r],[b[0],a[1]+dy*r],String(r))]),line(a,b),line([a[0],b[1]],[b[0],a[1]])];
    const labels = {
        'Cypher Pattern':['X','A','B','C','D'], 'Three Drives Pattern':['0','1','A','2','B','3','C'], 'Forecast':['A','B','Target'],
        'ABCD Pattern':['A','B','C','D'], 'XABCD Pattern':['X','A','B','C','D'],
        'Elliott Impulse Wave':['0','1','2','3','4','5'], 'Elliott Correction Wave':['0','A','B','C'],
        'Head and Shoulders':['','LS','','H','','RS',''], 'Triangle Pattern':['A','B','C','D','E'],
    }[kind];
    if (labels) return [{ type:'path', points,labels }];
    return [];
}
export function distanceToSegment(point,a,b) {
    const dx=b[0]-a[0],dy=b[1]-a[1],n=dx*dx+dy*dy;
    const f=n ? Math.max(0,Math.min(1,((point[0]-a[0])*dx+(point[1]-a[1])*dy)/n)) : 0;
    return Math.hypot(point[0]-a[0]-f*dx,point[1]-a[1]-f*dy);
}
